import { atom } from 'jotai';

export type CompanionType = 'alone' | 'friends' | 'couple' | 'family' | 'family_kids';

export const surveyAtom = atom<{
  fromDateTime?: string;
  toDateTime?: string;
  companion?: string | CompanionType;
  zones: {
    id: string;
    name: string;
    level: number;
  }[];
  customSlots: {
    days: {
      morning: boolean;
      afternoon: boolean;
      night: boolean;
    }[];
    placeId: string;
    poiType: string;
  }[];
  departurePoint?: {
    name: string;
    address: string;
    latitude: number;
    longitude: number;
  } | null;
}>({
  fromDateTime: undefined,
  toDateTime: undefined,
  companion: undefined,
  zones: [],
  customSlots: [],
  departurePoint: undefined,
});

export const selectedZonesAtom = atom<{
  zones: { id: string; name: string; level: number }[];
  details: { id: string; name: string; level: number }[];
}>({
  zones: [],
  details: [],
});

export const selectedCustomSlotAtom = atom<
  {
    name: string;
    address: string;
    poiType: string;
    placeId: string;
    accomm: {
      isVisit: boolean;
      days: number[];
      day: 'all' | number | null;
      time: 'all' | 1 | 2 | 3 | null;
    } | null;
    other: {
      day: 'all' | number | null;
      time: 'all' | 1 | 2 | 3 | null;
    } | null;
  }[]
>([]);
